import { type MCPServerInfo } from '../../types';

const PaypalServer: MCPServerInfo = {
  serverId: 'PAYPAL',
  name: 'PayPal',
  slug: 'paypal',
  description:
    "Interact with PayPal's payment ecosystem to process transactions, manage subscriptions, handle disputes, access customer payment data, generate financial reports, and monitor payment flows.",
  source: {
    sourceType: 'REMOTE_URL',
    mcpServerUrl: 'https://mcp.paypal.com/mcp',
    transport: 'STREAMABLE_HTTP'
  },
  authenticationType: 'OAUTH',
  serverConfig: {
    required: [],
    properties: {}
  },
  installConfig: {
    required: [],
    properties: {}
  }
};

export default PaypalServer;
